import React from 'react'
import { Contact } from '../component/Contact'
import { Footer } from '../layout/Footer'
import { Navigationbar } from '../layout/Navigationbar'

export const Contactpage = () => {
  return (
    <div>
        <Navigationbar/>
        <Contact/>
        <Footer/>
    </div>
  )
}
